
import SwedenRegulation from './sweden_regulation'
import {GNWP_SOURCES} from '../../../../../../app-react/services/gnwp/gnwp-consts';

export default class MrgreenSwedenRegulation extends SwedenRegulation {
    static CLASS = 'MrgreenSwedenRegulation';

    getTempAccountGnwpSource() {
        return GNWP_SOURCES.DOCUMENT_UPLOAD;
    }

}
